module.exports = __webpack_public_path__ + "static/media/social media.26775624.jpg";